import { render, staticRenderFns } from "./ArticlePage.vue?vue&type=template&id=1a75b18a"
import script from "./ArticlePage.vue?vue&type=script&lang=ts"
export * from "./ArticlePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/app/Header/Header.vue').default,CmStage: require('/app/components/modules/CmStage/CmStage.vue').default,Footer: require('/app/components/app/Footer/Footer.vue').default})
